const VALID_DATASET_TYPES_FOR_MARK_NULL = [
    "object-detection",
    "instance-segmentation",
    "semantic-segmentation"
];

module.exports = { VALID_DATASET_TYPES_FOR_MARK_NULL };
